module.exports = __webpack_public_path__ + "static/fanruan-job.9f3389d7.png";